// M004-F0749 (WebUI #191). Download the STORED PDF of an issued invoice (Spec 1.14.0 invoice.pdf, ACCT-INV-002). The bytes are decoded and
// checked against pdf_sha256 by the credit-note helper (a mismatch refuses the download), then saved under the server filename. The
// answer must be for the invoice asked about; a document for another invoice is refused.
import { invoiceApi } from '../../services/invoiceApi';
import { pdfBlobFromContract } from '../ledger/creditNotePdf';

export async function downloadInvoicePdf(orgId, invoice) {
  const response = await invoiceApi.pdf(orgId, invoice.invoice_id);
  const data = response?.data?.data;
  if (!data?.pdf_base64) throw new Error('The Ledger sent no document for this invoice.');
  if (data.invoice_id !== invoice.invoice_id) throw new Error('The Ledger answered with a different invoice, so nothing was downloaded.');
  const url = URL.createObjectURL(await pdfBlobFromContract(data));
  const link = document.createElement('a');
  link.href = url;
  link.download = data.filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
